const mutations = {
  setTabData(state, { tabName, data }) {
    if (state.tabData[tabName]) {
      state.tabData[tabName] = { ...state.tabData[tabName], ...data };
    }
  },

  resetTabData(state, tabName) {
    if (state.tabData[tabName]) {
      state.tabData[tabName] = {
        pagination: {
          itemsPerPage: 10,
          itemsPerPageArray: [10, 20, 50, 100],
          page: 1,
        },
        totalItems: 0,
        searchBy: "life_insured_name",
        searchValue: "",
        showBy: {},
        dateRange: null,
        claimStatus: {},
        selectedBanks: [],
      };
    }
  },
};

export default mutations;
